import type { SavingsConfig } from '../../ProductsConfig';

export const termDepositOverviewConfig: SavingsConfig['overview']['termDeposit'] = {
    showBalance: false,
    showFixedDeposit: false,
    showOpeningDate: false,
    showRollover: false,
    showCapitalization: false,
    showInterestBookingDisposition: false,
    showInterestBookingDispositionType: {
        subaccount: false,
        interestTransfer: false,
    },
    showDepositBookingDisposition: false,
    showCreditInterestRate: false,
    showCreditInterestRateBonus: false,
    showTotalInterestRate: false,
};
